import { getAxiosInstance } from '../api.client';
import { type Customer, type CustomerFormModel } from './customers.models';

export async function getCustomers(): Promise<Customer[]> {
    const response = await getAxiosInstance().get<Customer[]>('/Customer');
    return response.data;
}

export async function getCustomerById(id: string): Promise<Customer> {
    const response = await getAxiosInstance().get<Customer>(`/Customer/${id}`);
    return response.data;
}

export async function createCustomer(
    data: CustomerFormModel,
): Promise<Customer> {
    const response = await getAxiosInstance().post<Customer>('/Customer', data);
    return response.data;
}

export async function updateCustomer(
    id: string,
    data: CustomerFormModel,
): Promise<Customer> {
    const response = await getAxiosInstance().put<Customer>(
        `/Customer/${id}`,
        data,
    );
    return response.data;
}

export async function deleteCustomer(id: string): Promise<void> {
    await getAxiosInstance().delete(`/Customer/${id}`);
}
